import { ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DefaultLayout from './DefaultLayout';
import POSLayout from './POSLayout';
import WorkspaceLayout from './WorkspaceLayout';
import { getAppLayoutMode } from './appLayoutMode';

interface AppLayoutResolverProps {
  children?: ReactNode;
}

/**
 * Mantiene el shell apropiado por encima de las rutas. De esta forma, navegar
 * entre pantallas del mismo entorno solo reemplaza el contenido.
 */
const AppLayoutResolver: React.FC<AppLayoutResolverProps> = ({ children }) => {
  const { pathname } = useLocation();
  const content = children ?? <Outlet />;
  const mode = getAppLayoutMode(pathname);

  if (mode === 'pos') {
    return <POSLayout>{content}</POSLayout>;
  }

  if (mode === 'workspace') {
    return <WorkspaceLayout>{content}</WorkspaceLayout>;
  }

  return <DefaultLayout>{content}</DefaultLayout>;
};

export default AppLayoutResolver;
